<div class="body-card grey-rounded-scroll" *ngIf="accessEntries">
  <ng-container *ngFor="let door of accessEntries; let i = index">
    <div class="invitation-record"
      [ngClass]="door.checked && door.status === 'completed' ? 'completed' : door.status === 'time-exceeded' ? 'time-exceeded' : ''"
      *ngIf="door.checked || door.status == 'time-exceeded'">
      <div class="last-marking">
        <p class="door-name">{{ door?.doorName }}</p>
        <p class="marking" *ngIf="door.status !== 'time-exceeded'">
          {{ 'frequentAccess.securityCenter.marking' | translate }}: {{ door?.date ? getFormattedDate(door.date) : '--'
          }}
        </p>
        <div class="marking time-exceeded" *ngIf="door.status == 'time-exceeded'">
          {{ 'frequentAccess.securityCenter.marking' | translate }}: {{ door?.date ? getFormattedDate(door.date) : '--'
          }} |
          {{ 'frequentAccess.securityCenter.exceeded.by' | translate }}:
          <p class="hours">
            <span>{{door.timeEx.hours}} : {{door.timeEx.minutes}}</span>
            <span>HRS : MIN</span>
          </p>
        </div>
      </div>
      <div *ngIf="door?.checked || door?.status == 'time-exceeded'">
        <div *ngIf="door?.status != 'time-exceeded'" class="custom__status scanned">{{ ('status.invitations.scanned') | translate | uppercase }}</div>
        <div *ngIf="door?.status == 'time-exceeded'" class="custom__status time-exceeded">{{ ('status.invitations.time-exceeded') | translate | uppercase }}</div>
      </div>
    </div>
  </ng-container>
</div>